import React from "react";
import { ShoppingBag, ArrowRight, Truck, Star } from "lucide-react";
import { ASSETS, LINKS, BRAND } from "@/lib/brand";

export const Shop = () => {
  return (
    <section
      id="shop"
      data-testid="shop-section"
      className="relative py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="relative rounded-[2.5rem] bg-paula-yellow overflow-hidden">
          {/* big P decoration */}
          <div
            aria-hidden
            className="absolute -bottom-20 -right-10 font-display font-black text-[20rem] leading-none text-paula-ink/10 select-none"
          >
            P
          </div>

          <div className="relative grid lg:grid-cols-12 gap-10 p-8 sm:p-12 lg:p-16 items-center">
            <div className="lg:col-span-7">
              <div className="text-xs font-semibold uppercase tracking-[0.2em] text-paula-ink/70 mb-4">
                Im Shop
              </div>
              <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl text-paula-ink leading-[1.02] tracking-tight">
                Hol Dir Paula nach Hause —{" "}
                <span className="text-paula-red">für {BRAND.price}</span>.
              </h2>
              <p className="mt-6 text-paula-ink/80 text-lg max-w-xl leading-relaxed">
                Direkt im Shopify-Shop von „Rettungssanitäterin Pinguin Paula".
                Liebevoll illustriert, kindgerecht erzählt. Inklusive 3D-Anmal-Paula.
                Versand deutschlandweit.
              </p>

              <div className="mt-8 flex flex-wrap gap-3">
                <a
                  href={LINKS.shop}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="shop-cta-buy"
                  className="group inline-flex items-center gap-2 px-7 py-4 rounded-full bg-paula-ink text-white font-semibold hover:bg-paula-red transition-colors"
                >
                  <ShoppingBag size={18} />
                  Im Shopify-Shop kaufen
                  <ArrowRight
                    size={18}
                    className="transition-transform group-hover:translate-x-1"
                  />
                </a>
                <a
                  href={LINKS.amazon}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="shop-amazon-cta"
                  className="inline-flex items-center gap-2 px-7 py-4 rounded-full border-2 border-paula-ink text-paula-ink font-semibold hover:bg-white transition-colors"
                >
                  Bei Amazon.de
                </a>
              </div>

              <div className="mt-8 flex flex-wrap items-center gap-x-8 gap-y-3 text-sm text-paula-ink/70">
                <div className="flex items-center gap-2">
                  <Truck size={16} /> Schneller Versand
                </div>
                <div className="flex items-center gap-2">
                  <Star size={16} className="text-paula-red fill-paula-red" />
                  Direkt von der Autorin
                </div>
                <div className="flex items-center gap-2">
                  <span className="w-2 h-2 rounded-full bg-paula-ink" />
                  Inkl. 3D-Anmal-Paula
                </div>
              </div>
            </div>

            <div className="lg:col-span-5">
              <div
                data-testid="shop-qr-card"
                className="relative bg-white rounded-3xl p-7 max-w-sm mx-auto"
              >
                <div className="text-xs font-semibold uppercase tracking-[0.2em] text-paula-muted mb-3">
                  Direkt scannen
                </div>
                <div className="rounded-2xl bg-white p-2 grid place-items-center">
                  <img
                    src={ASSETS.shopQrCode}
                    alt="QR-Code zum Shopify-Shop"
                    className="w-56 h-56 object-contain"
                    data-testid="shop-qr-image"
                  />
                </div>
                <div className="mt-4 flex items-center justify-between">
                  <div>
                    <div className="font-display font-bold text-paula-ink text-lg leading-tight">
                      Rettungssanitäterin
                      <br />
                      Pinguin Paula
                    </div>
                    <div className="text-xs text-paula-muted mt-1">
                      Shopify · Erste-Hilfe-Ausmalbuch
                    </div>
                  </div>
                  <div className="text-paula-red font-display font-bold text-2xl">
                    {BRAND.price}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Shop;
